import React from "react";
import ImagesConstants from "../../../constants/ImagesConstants";

const ReleaseV5 = () => {
    return (
        <div className="release_content">
            <h3>DataBook Release Note Beta_V.1.3.0</h3>
            <div className="w-100 p-2">
                <p>Released on 8 Feb 2024</p>
                <div>
                    <p className="release-font-family">Empowering our Business & Tech teams has always been our top priority. We are excited to announce the latest updates to Maestro DataBook, your go-to self-serve data platform.</p>
                </div>
                <div>
                    <img alt="" src={ImagesConstants.RELEASE.DATABOOK_LANDING} className="w-75" />
                </div>
            </div>
            <div className="p-2 mt-5">
                <h3>What's new?</h3>
                <h2 className="py-3 release-font-family">1. Discover data assets faster through an optimised search engine.</h2>
                <div>
                    <img alt="" src={ImagesConstants.RELEASE.OPTIMIZED_SEARCH_DROP} className="w-75" />
                </div>
                <div className="py-3">
                    <p className="release-font-family">Discover data assets faster through an optimised search engine.</p>
                    <ul>
                        <li className="py-1 release-font-family">New category-wise search option</li>
                        <ul className="py-1">
                            <li className="py-1 release-font-family">
                                Search the metadata based on name, description, tag names, classification, and sensitivity.
                            </li>
                            <li className="py-1 release-font-family">
                                Search certified datasets owned by them.

                            </li>
                        </ul>
                        <li className="py-1 release-font-family">Exact keyword search using double quotes. For example- "Leave of Absence event"</li>
                    </ul>
                </div>
            </div>
            <div>
                <h2 className="py-3 release-font-family">2. Introducing Role-based Data Governance for enhanced control and security.</h2>
                <div>
                    <img alt="" src={ImagesConstants.RELEASE.ROLE_BASED_ACCESS} className="w-75" />
                </div>
                <div className="py-3">
                    <ul>
                        <li className="py-1 release-font-family">
                            Edit and save datasets (owned by them only). This feature has been implemented for following attributes - Description, tags, classification & sensitivity, owner information, certified dataset.
                        </li>
                        <li className="py-1 release-font-family">
                            Edit the datasets (owned by them only) via Bulk upload feature on Databook UI.
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <h2 className="py-3">3. Experience improved landing page performance</h2>
                <div>
                    <img alt="" src={ImagesConstants.RELEASE.IMPROVED_LANDING_PAGE} className="w-75" />
                </div>
                <p className="py-3">We have improved the Databook landing page performance for better user experience.</p>
            </div>
        </div>
    );
};

export default ReleaseV5;
